import { render } from "./FormScript.vue?vue&type=template&id=072b8e11"
import script from "./FormScript.vue?vue&type=script&setup=true&lang=js"
export * from "./FormScript.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/DesignSetting/FormScript.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "072b8e11"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('072b8e11', __exports__)) {
    console.log('reload')
    api.reload('072b8e11', __exports__)
  }
  
  module.hot.accept("./FormScript.vue?vue&type=template&id=072b8e11", () => {
    console.log('re-render')
    api.rerender('072b8e11', render)
  })

}


export default __exports__